import config from 'react-global-configuration';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST } from '@uncinc/react-drupal-core';


export const authorizeRiskMonitor = (values) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('sso', 'authorize', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
      .then((csrfResponse) => csrfResponse.text())
      .then((csrfResponse) => {
        const csrfToken = csrfResponse;
        let method = 'POST';
        let url = `${PATH}/oauth/authorize${window.location.search}`;

        fetch(url, {
          method: method,
          credentials: 'include',
          body: JSON.stringify(values),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            if (response.status !== 200) {
              dispatch(setOperationStatus('user', 'authorize', UI_OPERATION_STATUS_ERROR));
              throw new Error(response.status);
            }
            return response.json();
          })
          .then((response) => {
            if (response.url) {
              window.location.href = response.url;
            }
          })
          .catch(() => {
            dispatch(setOperationStatus('user', 'authorize', UI_OPERATION_STATUS_ERROR));
          });
      })
      .catch(() => {
        dispatch(setOperationStatus('user', 'authorize', UI_OPERATION_STATUS_ERROR));
      });
  };
};
